// "Orbit" (VIS-265, Film's action at a point; also a tour stop's move): the camera circles round what it looks at,
// or round `center`, the whole picture turning with it so the framing is kept. At rest when it begins and ends.
// Options (Film's action, or a stop's moveOptions):
//   turn    degrees round, + = clockwise seen from above (default 180: half way round)
//   center  [x, y, z] the point it circles (default: the point the camera looks at; a tour stop: its pivot)
//   travel  seconds of the flight to a tour stop (default 3.2)
import { easeInOut, posed, turnAbout } from './rig.js';

const num = (v, d) => (Number.isFinite(v) ? v : d);
const point = (p) => (Array.isArray(p) && p.length === 3 && p.every(Number.isFinite) ? p : null);

/** @param {import('./rig.js').View} view  @param {number} k  0..1 of the move  @returns {import('./rig.js').View} */
export function pose(view, k, o = {}) {
  const c = point(o.center) || view.target, deg = num(o.turn, 180) * easeInOut(Math.min(1, Math.max(0, k)));
  return { ...view, position: turnAbout(view.position, c, deg), target: turnAbout(view.target, c, deg) };
}

export default function orbit(o, rig) { return posed(pose, o, rig); }
